import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const paymentMethodService = {
    getAllMethods,
    getMethod,
    updateMethod,
    createMethod,
    updateMethodStatus 
};

const MODULE = {
    METHOD: 'payment-methods',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllMethods(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.METHOD}`, requestOptions)
  }

  export function getMethod(id) {   
    return apiHelper(API_URL).get(`/${MODULE.METHOD}/${id}`)
  }

  export function updateMethod(data) {
    
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.METHOD}/${data.id}`, requestOptions)
  }

  export function createMethod(data) {
    
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.METHOD}`, requestOptions)
  }

  export function updateMethodStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.METHOD}/${data.id}`, requestOptions)
    
  }